// NGRX STORE
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';

// STORE STATE
import { GlobalState } from './state';

// COMMON INTERFACES
import { PopupNotification } from '../../../models/global/popup/popup-notification.interface';

/**
 * These selectors are for get data from global reducer.
 * For get global data from store purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially create with few selectors.
 */
export const selectState: MemoizedSelector<
  object,
  GlobalState
> = createFeatureSelector<GlobalState>('global');

// -------------------------------
//  Popup Notification Selector
// -------------------------------
const getPopupNotification = (state: GlobalState): PopupNotification => state.popupNotification;
export const selectPopupNotification: MemoizedSelector<object, any> = createSelector(
  selectState,
  getPopupNotification,
);

// -------------------------------
//  Popup Notification Callback Selector
// -------------------------------
const getPopupNotificationCallback = (state: GlobalState): PopupNotification => state.popupNotificationCallback;
export const selectPopupNotificationCallback: MemoizedSelector<object, any> = createSelector(
  selectState,
  getPopupNotificationCallback,
);

// -------------------------------
//  Failure Error Selector
// -------------------------------
const getFailureError = (state: GlobalState): boolean => state.error;
export const selectGlobalError: MemoizedSelector<object, any> = createSelector(
  selectState,
  getFailureError,
);
